import Vue from 'vue';
import VueRouter from 'vue-router';
import units from '@/api/units';
import Index from '../pages/index.vue';
import login from '../pages/login.vue';
import insteadTbLogin from '../pages/insteadTbLogin.vue';
import Home from '../pages/home/home.vue';

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Index,
    name: 'Index',
    meta: {
      title: '首页'
    }
  },
  {
    path: '/test',
    component: () => import('../pages/test.vue'),
    meta: {
      title: '测试'
    }
  },
  {
    path: '/empty',
    component: () => import('../pages/empty.vue'),
    meta: {
      title: ''
    }
  },
  {
    path: '/other',
    component: () => import('../pages/other.vue'),
    meta: {
      title: '千策战场'
    }
  },
  {
    path: '/wtsLogin',
    component: () => import('../pages/wtsLogin.vue'),
    name: 'wtsLogin',
    meta: {
      title: '登录'
    }
  },
  {
    path: '/:code?/login',
    component: login,
    name: 'login',
    meta: {
      title: '登录'
    }
  },
  {
    path: '/insteadTbLogin',
    component: insteadTbLogin,
    name: 'insteadTbLogin',
    meta: {
      title: '登录'
    }
  },

  {
    path: '/home',
    component: Home,
    name: 'home',
    redirect: '/home/index',
    component: () => import('../pages/home/index.vue'),
    children: [
      {
        path: '/home/index',
        name: 'home',
        component: () => import('../pages/home/home.vue'),
        meta: {
          title: '首页'
        }
      },
      {
        path: '/home/chatMange',
        name: 'chatMange',
        component: () => import('../pages/home/chatMange.vue'),
        meta: {
          title: '消息公告'
        }
      },
      {
        path: '/home/detail',
        name: 'chatMange',
        component: () => import('../pages/home/detail.vue'),
        meta: {
          title: '消息公告详情'
        }
      }
    ]
  },
  // {
  /*********消息公告**********/


  /*********产品资源**********/
  // 商品库
  {
    path: '/productResource/',
    redirect: '/productResource/product/view',
    meta: {
      title: '产品资源'
    },
    component: () => import('../pages/router.vue'),
    children: [
      {
        path: '/productResource/product/view',
        redirect: '/productResource/product/index',
        meta: {
          title: '商品库中心'
        },
        component: () => import('../pages/router.vue'),
        children: [
          {
            path: '/productResource/product/index',
            name: 'product',
            component: () => import('../pages/productResource/product/index.vue'),
            meta: {
              keepAlive: true
            }
          },
          {
            path: '/productResource/product/lookServer',
            name: 'lookServer',
            component: () => import('../pages/productResource/product/lookServer.vue'),
            meta: {
              title: '查看服务费',
              keepAlive: true
            }
          },
          {
            path: '/productResource/product/insuranceLink',
            name: 'insuranceLink',
            component: () => import('../pages/productResource/product/insuranceLink.vue'),
            meta: {
              title: '查看投保链接'
            }
          },
          {
            path: '/productResource/product/promotional',
            name: 'promotional',
            component: () => import('../pages/productResource/product/promotional.vue'),
            meta: {
              title: '推广资料'
            }
          }
        ]
      },
      {
        path: '/productResource/zeroInsure/index',
        component: () => import('../pages//productResource/zeroInsure/index.vue'),
        meta: {
          keepAlive: true,
          title: '赠险库'
        }
      },
    ]
  },


  /*********业务管理**********/
  {
    path: '/orderManage',
    redirect: '/orderManage/order/order',
    meta: {
      title: '业务管理'
    },
    component: () => import('../pages/router.vue'),
    children: [
      {
        path: '/orderManage/order/order',
        redirect: '/orderManage/order/order',
        meta: {
          title: '人身险'
        },
        component: () => import('../pages/router.vue'),
        children: [
          {
            path: '/orderManage/order/order',
            name: 'order',
            component: () => import('../pages/orderManage/order/order.vue'),
            meta: {
              title: '人身险订单',
              keepAlive: true
            }
          },
          {
            path: '/orderManage/waitOrder/order',
            name: 'waitOrder',
            component: () => import('../pages/orderManage/waitOrder/order.vue'),
            meta: {
              title: '代投订单',
              keepAlive: true
            }
          },
          {
            path: '/orderManage/insuredOrder/main',
            name: 'insureOrder',
            component: () => import('../pages/orderManage/insuredOrder/order.vue'),
            meta: {
              title: '人身险保单',
              keepAlive: true
            }
          },
          {
            path: '/orderManage/appointmentOrder',
            name: 'appointmentOrder',
            component: () => import('../pages/orderManage/appointmentOrder/index.vue'),
            meta: {
              title: '预约投保单',
              keepAlive: true
            }
          },
          {
            path: '/orderManage/qualityTesting',
            name: 'qualityTesting',
            component: () => import('../pages/orderManage/qualityTesting/index.vue'),
            meta: {
              title: '质检单管理',
              keepAlive: true
            }
          },
          {
            path: '/orderManage/signOrder/individual',
            name: 'qualityTesting',
            component: () => import('../pages/orderManage/signOrder/individual.vue'),
            meta: {
              title: '个险签单',
              keepAlive: true
            }
          }
        ]
      },

      {
        path: '/renewalGroupManage',
        component: () => import('../pages/router.vue'),
        meta: {
          title: "团财续保管理",
        },
        children: [
          {
            path: '/renewalManage/renewalGroupManage',
            component: () => import('../pages/orderManage/renewalGroupManage/index'),
            meta: {
              keepAlive: true
            },
          },
          {
            path: '/renewalManage/renewalGroupManage/detail',
            name: 'renewalGroupManage.detail',
            component: () => import('../pages/orderManage/renewalGroupManage/detail'),
            meta: {
              title: "团财续保详情",
              parentUrl: '/renewalManage/renewalGroupManage',
            },
          },
          {
            path: '/orderManage/signOrder/group',
            name: 'qualityTesting',
            component: () => import('../pages/orderManage/signOrder/group.vue'),
            meta: {
              title: '团险签单',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: '/orderManage/group/order',
        name: 'orderManage.group',
        component: () => import('../pages/router.vue'),
        meta: {
          title: '团财险订单'
        },
        children: [
          {
            path: '/orderManage/group/order',
            name: 'orderManage.group.order',
            component: () => import('../pages/orderManage/group/order/index'),
            meta: {
              title: '投保订单',
              keepAlive: true
            }
          },
          {
            path: '/orderManage/group/order/detail',
            name: 'orderManage.group.order.detail',
            component: () => import('../pages/orderManage/group/order/detail.vue'),
            meta: {
              title: '投保订单详情'
            }
          },
          {
            path: '/orderManage/group/peservation',
            name: 'orderManage.group.peservation',
            component: () => import('../pages/orderManage/group/peservation/index'),
            meta: {
              title: '保全订单',
              keepAlive: true
            }
          },
          {
            path: '/orderManage/group/peservation/detail',
            name: 'orderManage.group.peservation.detail',
            component: () => import('../pages/orderManage/group/peservation/detail'),
            meta: {
              title: '保全订单详情'
            }
          },
          {
            path: '/orderManage/group/peservation/policyDetail',
            name: 'orderManage.group.policyDetail',
            component: () => import('../pages/orderManage/group/policy/policyDetail.vue'),
            meta: {
              title: "团财险保单详情",
              parentUrl: '/orderManage/group/peservation',
            },
          },
        ]
      },
      {
        path: '/orderManage/group/policy',
        redirect: '/orderManage/group/policy',
        component: () => import('../pages/router.vue'),
        meta: {
          title: '团财险保单'
        },
        children: [
          {
            path: '/orderManage/group/policy',
            name: 'orderManage.group.policy',
            component: () => import('../pages/orderManage/group/policy/index.vue'),
            meta: {
              keepAlive: true
            }
          },
          {
            path: '/orderManage/group/policyDetail',
            name: 'orderManage.group.policyDetail',
            component: () => import('../pages/orderManage/group/policy/policyDetail.vue'),
            meta: {
              title: '团财险保单详情',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: '/orderManage/group/invoiceList',
        name: 'orderManage.group.invoiceList',
        component: () => import('../pages/orderManage/group/policy/invoiceList.vue'),
        meta: {
          title: '申请开票'
        }
      }
    ]
  },
  /*********业务管理**********/
  {
    path: '/business',
    redirect: '/customerManage/list',
    meta: {
      title: '业务管理'
    },
    component: () => import('../pages/router.vue'),
    children: [
      {
        path: '/orderManage/zeroInsure/order/index',
        component: () => import('../pages/router.vue'),
        meta: {
          title: '赠险订保单'
        },
        children: [
          {
            path: '/orderManage/zeroInsure/order/index',
            name: 'orderManage.zeroInsure.order.index',
            component: () => import('../pages/orderManage/zeroInsure/order/index.vue'),
            meta: {
              title: '赠险订单',
              keepAlive: true
            }
          },
          {
            path: '/orderManage/zeroInsure/policy/index',
            name: 'orderManage.zeroInsure.policy.index',
            component: () => import('../pages/orderManage/zeroInsure/policy/index.vue'),
            meta: {
              title: '赠险保单',
              keepAlive: true
            }
          }
        ]
      }
    ]
  },
  {
    path: '/customerManage/list',
    redirect: '/customerManage/list',
    meta: {
      title: '客户管理'
    },
    component: () => import('../pages/router.vue'),
    children: [
      {
        path: '/customerManage/list',
        name: 'customerManage',
        component: () => import('../pages/customerManage/customer/index.vue'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/customerManage/channelDetail',
        name: 'customerDetail',
        component: () => import('../pages/customerManage/customer/channelDetail.vue'),
        meta: {
          title: '客户详情'
        }
      },
      {
        path: '/customerManage/salesmanDetail',
        name: 'customerDetail',
        component: () => import('../pages/customerManage/customer/salesmanDetail.vue'),
        meta: {
          title: '客户详情',
          keepAlive: true
        }
      }
    ]
  },
  /*********财务管理**********/
  {
    path: '/financialManage',
    redirect: '/financialManage/myIncome',
    meta: {
      title: '收入管理'
    },
    component: () => import('../pages/financialManage/index'),
    children: [
      {
        path: '/financialManage/myIncome',
        meta: {
          title: '我的收入'
        },
        component: () => import('../pages/financialManage/index'),
        children: [
          {
            path: '/financialManage/myIncome',
            meta: {
              title: '',
              keepAlive: true
            },
            component: () => import('../pages/financialManage/myIncome/index.vue')
          },
          {
            path: '/financialManage/myIncome/detail',
            meta: {
              title: '收入明细'
            },
            component: () => import('../pages/financialManage/myIncome/detail')
          },
          {
            path: '/financialManage/myIncome/settledDetailTabs',
            meta: {
              title: '待结算明细',
              keepAlive: true
            },
            component: () => import('../pages/financialManage/myIncome/settledDetailTabs')
          }
        ]
      },
      {
        path: '/financialManage/myWithdrawal',
        meta: {
          title: '我的提现'
        },
        component: () => import('../pages/financialManage/index'),
        children: [
          {
            path: '/financialManage/myWithdrawal',
            meta: {
              title: '',
              keepAlive: true
            },
            component: () => import('../pages/financialManage/myWithdrawal/index.vue')
          },
          {
            path: '/financialManage/myWithdrawal/detail',
            meta: {
              title: '收入明细'
            },
            component: () => import('../pages/financialManage/myIncome/detail')
          }
        ]
      }
    ]
  },
  {
    path: '/workOrder',
    meta: {
      title: "工单管理"
    },
    component: () => import('../pages/router'),
    children: [
      {
        path: '/workOrder/claimManage',
        meta: {
          title: "理赔管理",
          keepAlive: true
        },
        component: () => import('../pages/workOrder/claimManage/index.vue'),
      }
    ]
  },
  /*********续期管理**********/
  {
    path: '/renewalManage',
    redirect: '/renewalManage/renewManage',
    meta: {
      title: "续期管理"
    },
    component: () => import('../pages/router.vue'),
    children: [
      {
        path: '/renewalManage/renewalManage',
        redirect: '/renewalManage/renewalManage',
        component: () => import('../pages/router.vue'),
        meta: {
          title: '短险续保管理'
        },
        children: [
          {
            path: '/renewalManage/renewalManage',
            name: 'renewalManage',
            component: () => import('../pages/orderManage/renewalManage/index.vue'),
            meta: {
              keepAlive: true
            }
          },
          {
            path: '/renewalManage/renewalManage/detail',
            name: 'renewalManageDetail',
            component: () => import('../pages/orderManage/renewalManage/detail.vue'),
            meta: {
              title: '续保管理详情',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: '/renewalManage/renewManage',
        redirect: '/renewalManage/renewManage',
        component: () => import('../pages/router.vue'),
        meta: {
          title: '长险续费管理'
        },
        children: [
          {
            path: '/renewalManage/renewManage',
            name: 'renewManage',
            component: () => import('../pages/orderManage/renewManage/index.vue'),
            meta: {
              keepAlive: true
            }
          },
          {
            path: '/renewalManage/renewManage/detail',
            name: 'renewManageDetail',
            component: () => import('../pages/orderManage/renewManage/detail'),
            meta: {
              title: '续费管理详情',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: '/renewalManage/continuityRate',
        name: 'renewalManage.continuityRate',
        component: () => import('../pages/router.vue'),
        meta: {
          title: '继续率管理'
        },
        children: [
          {
            path: '/renewalManage/continuityRate/group',
            name: 'renewalManage.continuityRate.search3',
            component: () => import('../pages/orderManage/continuityRate/search/index'),
            meta: {
              title: '团队继续率统计',
              keepAlive: true
            }
          },
          {
            path: '/renewalManage/continuityRate/person',
            name: 'renewalManage.continuityRate.search4',
            component: () => import('../pages/orderManage/continuityRate/search/index'),
            meta: {
              title: '个人继续率统计',
              keepAlive: true
            }
          },
          {
            path: '/renewalManage/continuityRate/policyList',
            name: 'renewalManage.continuityRate.policyList',
            component: () => import('../pages/orderManage/continuityRate/search/policyList'),
            meta: {
              title: '保单列表'
            }
          }
        ]
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

let modalHistoryList = [];
router.afterEach((to, from) => {
  const list = [];
  console.log('to', to);
  modalHistoryList.forEach((item, i) => {
    if (to.fullPath == item.url) {
      item.vueObj.visible = true;
    } else {
      list.push(item);
    }
  });
  modalHistoryList = list;
  // 根据 缓存 设置scrollTop
  const pageScrollInfo = sessionStorage.pageScrollInfo ? JSON.parse(sessionStorage.pageScrollInfo) : {};
  const scrollTop = pageScrollInfo[to.fullPath];
  delete pageScrollInfo[to.fullPath];
  sessionStorage.pageScrollInfo = JSON.stringify(pageScrollInfo);
  window.setTimeout(() => {
    document.documentElement.scrollTop = scrollTop || 0;
  }, 100);
});
router.beforeEach((to, from, next) => {
  // 记录当前页面滚动条位置
  let pageScrollInfo = sessionStorage.pageScrollInfo ? JSON.parse(sessionStorage.pageScrollInfo) : {};
  pageScrollInfo[from.fullPath] = document.documentElement.scrollTop;
  sessionStorage.pageScrollInfo = JSON.stringify(pageScrollInfo);
  // 隐藏所有弹窗
  document.querySelectorAll('.ivu-modal-wrap').forEach(item => {
    saveModalHistory(from, item.parentNode.__vue__);
    item.parentNode.__vue__ && item.parentNode.__vue__.close && item.parentNode.__vue__.close();
  });
  // 抽屉
  document.querySelectorAll('.ivu-drawer-wrap').forEach(item => {
    saveModalHistory(from, item.parentNode.__vue__);
    item.parentNode.__vue__ && item.parentNode.__vue__.close && item.parentNode.__vue__.close();
  });
  // 下拉select
  document.querySelectorAll('.ivu-select').forEach(item => {
    item.__vue__ && item.__vue__.hideMenu && item.__vue__.hideMenu();
  });
  // 日期组件
  document.querySelectorAll('.ivu-date-picker').forEach(item => {
    item.__vue__.visible = false;
  });
  let hasLogin = localStorage.getItem('hasLogin');
  const loginPage = ['wtsLogin', 'login', 'web.login', 'insteadTbLogin', 'loginExamine'];
  document.title = '保险中介展业平台';
  if (loginPage.includes(to.name)) {
    if (hasLogin) {
      next('/');
    } else {
      next();
    }
  } else {
    if (!hasLogin) {
      units.goLogin();
    } else {
      const url = to.path;
      if (url && url != '/' && url != '/home' && url != '/empty') {
        const arr = [];
        to.matched.forEach(item => {
          if (item.meta.title && item.meta.title != '首页') {
            arr.push({
              name: item.meta.title,
              path: item.path,
              noclick: item.path ? false : true
            });
          }
        });
        window.parent.postMessage(
          {
            updateNav: url,
            appMessage: true,
            nav: arr
          },
          '*'
        );
        // tag消息
        const matched = to.matched.filter(item => {
          return !!item.meta.title;
        });
        window.parent.postMessage(
          {
            webChange: {
              path: to.path,
              fullPath: to.fullPath,
              title: matched.length ? matched[matched.length - 1].meta.title : ''
            },
            appMessage: true
          },
          '*'
        );
      }
      try {
        next();
      } catch (error) {
        console.log('next.onError', error);
        window.setTimeout(() => {
          location.replace(url);
        }, 5000);
      }
    }
  }
});
export default router;

// 缓存切换路由时关闭的弹窗
function saveModalHistory(from, vueObj) {
  if (!vueObj) {
    return;
  }
  if (vueObj.visible) {
    if (vueObj.$parent.visible) {
      modalHistoryList.push({
        url: from.fullPath,
        vueObj: vueObj.$parent
      });
    } else {
      modalHistoryList.push({
        url: from.fullPath,
        vueObj: vueObj
      });
    }
  }
}
